import { render, staticRenderFns } from "./ModalErrorImap.vue?vue&type=template&id=22d17c19&scoped=true&"
import script from "./ModalErrorImap.vue?vue&type=script&lang=js&"
export * from "./ModalErrorImap.vue?vue&type=script&lang=js&"
import style0 from "./ModalErrorImap.vue?vue&type=style&index=0&id=22d17c19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d17c19",
  null
  
)

export default component.exports